/**
 * 모니터링 — **사업장 현황** 한 보기다(지역 › 공장 › 화면 나무와 그 범위의 그림, 다른 망의 서버까지 한 판).
 *
 * 모니터링을 여는 사람의 첫 질문은 "어느 현장에 문제가 있나" 다. 화면이 수십 대를 넘고 현장이 여러 망에 흩어지면
 * 그림 벽에서 그 답을 찾을 수 없다. 나무에서 지역·공장을 골라 좁혀 들어가 화면을 본다.
 *
 * 2026-10-22 까지는 왼쪽 메뉴에 "사업장 현황"(접이 메뉴 안에 나무)과 "화면 멀티뷰"(본 서버 화면의 지금 모습 벽) 두
 * 보기가 있었다. 사용자 지시("화면 멀티뷰는 지우고 사업장 현황 하나로, 드롭다운 없이 사업장 이름과 그 지역·회사를
 * 드롭다운으로")로 멀티뷰를 걷고, 왼쪽 판은 사업장 이름을 머리로 한 나무 하나가 됐다(`Sites.tsx` 의 `SiteTree`).
 * 화면 한 대의 지금 모습은 화면 상세에서 본다.
 *
 * **그림판이 본문을 여백 없이 꽉 채운다**(`AdminLayout` 의 꽉 찬 화면). 점 모눈 바탕 하나 위에 왼쪽 나무·도구 줄이
 * 떠 있다. 다른 서버와 연동된 서버의 **통합 모니터링**(원격 서버까지 한 지도)은 따로 메뉴다(`/integrated`, 2026-10-28) — 예전
 * 전환 주소(`/wall?view=map`)로 들어오면 그리로 옮겨 준다. 어느 범위인지는 주소(`?region=&site=&display=`)에 남겨 새로 고쳐도·링크로
 * 보내도 같은 자리가 열린다.
 */
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { Me, SignageOneClient } from '../api/client.js';
import { canOpen, navCapabilities } from '../nav.js';
import type { SitesView } from '../sites.js';
import { SitesWorkspace } from './Sites.js';

export function MonitoringScreen({ client, me, view }: { client: SignageOneClient; me: Me; view: SitesView }): ReactNode {
  const location = useLocation();
  // 예전 전환 주소(`/wall?view=map`) — 통합 모니터링을 볼 수 있으면 그 메뉴로, 아니면 그림판 그대로.
  if (view === 'board' && new URLSearchParams(location.search).get('view') === 'map' && canOpen('/integrated', navCapabilities(me))) {
    const rest = new URLSearchParams(location.search);
    rest.delete('view');
    const query = rest.toString();
    return <Navigate to={`/integrated${query ? `?${query}` : ''}`} replace />;
  }
  return (
    <div className="monitor-canvas animate-fade-in">
      {/* 보기가 바뀌면 처음부터 — 범위·카메라·받은 목록이 다른 보기의 것으로 남지 않게. */}
      <SitesWorkspace key={view} client={client} me={me} view={view} />
    </div>
  );
}
